/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_GeneralInputs */



/**
* | output |
* | --- |
* | "General" |
*
* @param {Event_Group_Options_Tab_GeneralInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_general = /** @type {((inputs?: Event_Group_Options_Tab_GeneralInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_GeneralInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Général")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общий")
	if (locale === "es") return /** @type {LocalizedString} */ ("General")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("一般的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一般的な")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामान्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Em geral")
	return /** @type {LocalizedString} */ ("General")
});